// import { useState } from 'react';
import { Form } from 'antd';
import { Moment } from 'moment';
import { FormContentLayout } from '../FormContentLayout';
// import 'antd/dist/antd.css';
import styles from './index.module.css';
import { EddLayout } from '../EddLayout';
import { EddSteps, EddShortSteps, NON_SHIPPING_DAYS_FORM_NAME } from '../../constants';
import { getUrlParams } from '../../utils/get-url-params';
import { ButtonPair } from '../ButtonPair';
import DateRangePicker from '../../../Test/DateRangePicker';

const NON_SHIPPING_DAYS_TITLE = 'Any expected order processing delay in the near future?';
const NON_SHIPPING_DAYS_DESCRIPTION = 'Let us know if you are expecting an upcoming fulfillment delay (i.e strikes, company holidays, etc), so we can factor that into your estimated delivery date.';

const NonShippingDays = () => {
  const type = getUrlParams().get('type');
  const dataSufficient = type === 'data-sufficient';
  const form = Form.useFormInstance();
  // const [value, setValue] = useState(form.getFieldValue(NON_SHIPPING_DAYS_FORM_NAME));
  const handleValueChange = (data: Moment | null) => {
    // setValue(data);
    form.setFieldValue(NON_SHIPPING_DAYS_FORM_NAME, data);
  };
  return (
    <EddLayout left={(
      <FormContentLayout
        title={NON_SHIPPING_DAYS_TITLE}
        description={NON_SHIPPING_DAYS_DESCRIPTION}
        step={dataSufficient ? EddShortSteps.FIRST : EddSteps.THIRD}
        dataSufficient={dataSufficient}
      >
        <div className={styles.daysOff}>Days off</div>
        <DateRangePicker onChange={handleValueChange} />
        {/* <DatePicker value={value} onChange={handleValueChange} /> */}
        <ButtonPair
          step={dataSufficient ? EddShortSteps.FIRST : EddSteps.THIRD}
          dataSufficient={dataSufficient}
          disableNext={false}
        />
      </FormContentLayout>
)}
    />
  );
};

export { NonShippingDays };
